import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import Axios from "axios";
import { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAdminRoute } from "./AdminMaster/AdminMaster";
import "./App.css";
import Atharo from "./Atharo";
import {FallbackPage} from "./FallbackPage/FallbackPage";
import JobsPage from "./JobsPage/JobsPage";
import Login from "./Login";
import CareersPage2024 from './CareersPage2024/CareersPage2024';
import NewStudentFormTwo from "./NewStudentForm/NewStudentFormTwo/NewStudentFormTwo";
import AutoFillNewStudentForm from "./NewStudentForm/AutoFillNewStudentForm/AutoFillNewStudentForm.js"
import NewStudentFormWithSecurity from "./NewStudentForm/NewStudentFormWithSecurity";
import ReviewForm from "./ReviewForm/ReviewForm";
import TeacherPortal2021 from "./TeacherPortal2021/TeacherPortal2021";
import TeacherInvitationScreen from "./TeacherInvitationScreen/TeacherInvitationScreen";
import TeacherAssessmentForm from "./TeacherAssessmentForm/TeacherAssessmentForm";
import StudentPolicies from "./StudentPolicies/StudentPolicies";
//import StudentPolicies2025 from "./StudentPolicies/StudentPolicies2025";
import NewStudentOffer2024 from "./NewStudentOffer2024/NewStudentOffer2024";
import CalendlyBookingDemo from "./CalendlyBookingDemo/CalendlyBookingDemo";
import { baseUrl } from "./assets/Animations";

const App = () => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState({});
  const [subdomainName, setSubdomainName] = useState("");

  const myToken = localStorage.getItem("token");
  const myHeader = {headers: { Authorization: `Bearer ${myToken}` }};

  useEffect(() => {
    setTheSchool();
    const accessToken = localStorage.getItem("token");
    const email = localStorage.getItem("user");
    if (accessToken) {
      Axios.get(`${baseUrl}/data/${email}`, myHeader)
        .then((res) => {
          setUserData(res.data);
          setUser(res.data.Email);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);


  const getLastPart = (url: string) => {
    const parts = url.split("/");
    return url.lastIndexOf("/") !== url.length - 1
      ? parts[parts.length - 1]
      : parts[parts.length - 2];
  };

  const setTheSchool = () => {
    const url = window.location.href;
    const trimmed = url.substring(8);
    const name = trimmed.split(".")[0];
    setSubdomainName(name);
  };

  const onLoggedIn = (authData) => {
    localStorage.setItem("token", authData.token);
    localStorage.setItem("user", authData.user.Email);
    setUserData(authData.user);
    setUser(authData.user.Email);
  };



  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.reload();
  };

  const httpLink = createHttpLink({
    uri: "https://gql.waveapps.com/graphql/public",
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: "Bearer 6jdTcRqxxC8fimWfzDm5ZN9c3TNr4b",
      },
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  const adminRoute = useAdminRoute({
    userData: userData,
    logout: () => logout(),
    user: user,
  });

  const router = createBrowserRouter([
    {
      path: "/",
      exact: true,
      element: <Atharo />,
    },
    {
      path: "/new-student-form",
      exact: true,
      element: <AutoFillNewStudentForm hasFamilyId={false} subdomainName={subdomainName} />,
    },
    {
      path: "/new-student/:familyId",
      exact: true,
      element: <AutoFillNewStudentForm hasFamilyId={true} subdomainName={subdomainName} />,
    },
    {
      path: "/newstudentform",
      exact: true,
      element: <NewStudentFormTwo />,
    },
    {
      path: "/newstudentform/:familyId",
      exact: true,
      element: <NewStudentFormWithSecurity />,
    },
    {
      path: "/providers/:school/:instrument/review",
      exact: true,
      element: <ReviewForm />,
    },
    {
      path: "/student-policies/:familyId",
      exact: true,
      element: <StudentPolicies />
    },
    {
      path: "/new-student-offer/:familyId/:teacherId",
      exact: true,
      element: <NewStudentOffer2024 />,
    },
    {
      path: "/admin",
      exact: true,
      ...(userData.IsAdmin
        ? adminRoute
        : {
            element: (
              <Login
                accessPoint={"admin"}
                onLoggedIn={(user) => onLoggedIn(user)}
              />
            ),
          }),
    },
    {
      path: "/teacherportal",
      exact: true,
      element: user ? (
        <TeacherPortal2021
          logout={() => logout()}
          userData={userData}
          user={user}
        />
      ) : (
        <Login
          accessPoint={"teacher"}
          onLoggedIn={(user) => onLoggedIn(user)}
        />
      ),
    },
    {
      path: "/careers",
      exact: true,
      element: <CareersPage2024 />,
    },
    {
      path: "/invitation/:invitationId/:answer",
      exact: true,
      element: <TeacherInvitationScreen />
    },
    {
      path: "/teacher-assessment/:familyId/:teacherId",
      exact: true,
      element: <TeacherAssessmentForm />
    },
    {
      path: "/booking-demo",
      exact: true,
      element: <CalendlyBookingDemo />,
    },
    {
      path: "*",
      element: <FallbackPage />,
    },
  ]);

  return (
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
    </ApolloProvider>
  );
};

export default App;































































// class App extends Component {
//   constructor() {
//     super()
//     state = {
//       user: null,
//       userData: {},
//       adminConversations: [],
//       unreadMessage: [],
//       anythingUnread: false,
//       theNewMsg: null
//     }
//   }

//   componentDidMount = async () => {
//     let accessToken = localStorage.getItem('token');
//     let email = localStorage.getItem('user')
//     if (accessToken !== null) {
//       await getTeacherInfo(accessToken, email);
//     } else {
//       let endPoint = getLastPart(window.location.href)
//       if(endPoint === 'admin') {
//         getAllChatsFromApi()
//       }
//     }
//   }

//   getLastPart(url) {
//     var parts = url.split("/");
//     return (url.lastIndexOf('/') !== url.length - 1
//        ? parts[parts.length - 1]
//        : parts[parts.length - 2]);
// }

//   componentDidUpdate = () => {
//     //LOG THE NEW MESSAGE
//     if(theNewMsg) {
//       logTheNewMessage(theNewMsg)
//       setTheNewMsg(null)
//     }
//   }

//   logTheNewMessage = (message) => {
//     let arrayToEdit = adminConversations
//     for(let i = 0; i < arrayToEdit.length; i++) {
//         if(arrayToEdit[i].RoomId === message.message.RoomId){
//             arrayToEdit[i].Messages.push(message.message)
//             logConvos(arrayToEdit)
//             if(message.message.Sender !== userData.Name) {
//               checkForUnreadMessages(arrayToEdit)
//             }
//         }
//     }
//     if(!message.message.ListOfReaders.includes(userData.Name)) {
//         let holder = unreadMessage
//         if(!holder.includes(message.message.RoomId)) {
//             holder.push(message.message.RoomId)
//             setUnreadMessage(holder)
//         }
//     }
// }

//   getAllChatsFromApi = async () => {
//     if (window.location.href.startsWith('http://localhost:3000')) {
//     return
//     } else {
//       let myToken = localStorage.getItem('token')
//       Axios.get('https://app.atharo.app/chats', {
//         headers: { Authorization: `Bearer ${myToken}` }
//       })
//       .then(response => {
//         logConvos(response.data)
//       })
//       .catch(err => {
//         console.log(err)
//       })
//     }
//   }

//   checkForUnreadMessages = (convos) => {
//     let unreadArray = unreadMessage
//     convos.forEach(convo => {
//       if(!convo.Messages[convo.Messages.length - 1].ListOfReaders.includes(userData.Name)) {
//           if(!unreadArray.includes(convo.RoomId)) {
//               unreadArray.push(convo.RoomId)
//           }
//       }
//     });
//     setState({
//       unreadMessage: unreadArray
//     }, () => {
//       checkForAnythingUnread()
//     })
//   }

//   checkForAnythingUnread = () => {
//     if(unreadMessage.length > 0) {
//       setState({
//         anythingUnread: true
//       })
//     } else {
//       setState({
//         anythingUnread: false
//       })
//     }
// }
//   setAnythingUnread = (bool) => {
//     setState({
//       anythingUnread: bool
//     })
//   }

//   setUnreadMessage = (msg) => {
//     setState({
//       unreadMessage: msg
//     })
//   }
//   setTheNewMsg = (msg) => {
//     setState({
//       theNewMsg: msg
//     })
//   }

//   disconnectFromSocket = () => {
//     socket.emit('disconnect', userData.Name)
//     socket.off = socket.removeListener;
//   }

//   componentWillUnmount = () => {
//     disconnectFromSocket()
//   }

//   getTeacherInfo = async (token, email) => {
//     localStorage.setItem('token', token)
//     localStorage.setItem('user', email)
//     Axios.get(`https://app.atharo.app/data/${email}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//     .then(response => {
//       let endPoint = getLastPart(window.location.href)
//       if(endPoint === 'admin') {
//         joinARoom(response.data.Name, 'mma-chat')
//       }
//       setState({
//         userData: response.data,
//         user: localStorage.getItem('user')
//       }, () => {
//         let endPoint = getLastPart(window.location.href)
//         if(endPoint === 'admin') {
//           getAllChatsFromApi()
//         }
//       });
//     })
//     .catch(function (error) {
//       console.log(error)
//     })
//   }

//   logConvos = (convos) => {
//     let convoArray = []
//     for(let i = 0; i < convos.length; i++) {
//       if(userData.ChatRooms.includes(convos[i].RoomId)) {
//         convoArray.push(convos[i])
//       }
//     }
//     setState({
//       adminConversations: convoArray
//     }, () => {
//       checkForUnreadMessages(adminConversations)
//     })
//   }

//   onLoggedIn(authData) {
//     if (window.location.href.startsWith('http://localhost:3000')) {
//       setState({
//         user: authData.Email,
//         userData: authData
//       })
//     } else {
//       getTeacherInfo(authData.token, authData.user.Email)
//     }
//   }

//   finallySendAMessage = (msg) => {
//     socket.emit('sendMessage', msg)
//   }

//   logout = () => {
//     localStorage.removeItem('token')
//     localStorage.removeItem('user')
//     window.location.reload()
//   }

//   render() {
//     let { user } = state
//     let { userData } = state

//     const httpLink = createHttpLink({
//       uri: 'https://gql.waveapps.com/graphql/public',
//     });

//     const authLink = setContext((_, { headers }) => {
//       return {
//         headers: {
//           ...headers,
//           authorization: `Bearer 6jdTcRqxxC8fimWfzDm5ZN9c3TNr4b`,
//         }
//       }
//     });

//     const client= new ApolloClient({
//       link: authLink.concat(httpLink),
//       cache: new InMemoryCache()
//     })

//     return (
//       <ApolloProvider client={client}>
//         <Router>
//           <Switch>
//             <Route path={'/'} exact component={Atharo} />
//             <Route path={'/newstudentform'} exact component={NewStudentForm} />
//             <Route path={'/admin'} exact render={() => {
//               if (!user) return <Login accessPoint={'admin'} onLoggedIn={user => onLoggedIn(user)} logConvos={logConvos} />;
//               return userData.School === 'admin' && <AdminMaster
//                                                         userData={userData}
//                                                         logout={() => logout()}
//                                                         user={user}
//                                                         finallySendAMessage={finallySendAMessage}
//                                                         adminConversations={adminConversations}
//                                                         logConvos={logConvos}
//                                                         disconnectFromSocket={disconnectFromSocket}
//                                                         setUnreadMessage={setUnreadMessage}
//                                                         unreadMessage={unreadMessage}
//                                                         setAnythingUnread={setAnythingUnread}
//                                                         anythingUnread={anythingUnread}
//                                                         checkForAnythingUnread={checkForAnythingUnread}
//                                                         setTheNewMsg={setTheNewMsg}
//                                                         getAllChatsFromApi={getAllChatsFromApi}
//                                                     />
//             }} />
//             <Route path={'/teacherportal'} exact render={() => {
//               if (!user) return <Login accessPoint={'teacher'} onLoggedIn={user => onLoggedIn(user)} />;
//               return <TeacherDashboard logout={() => logout()} userData={userData} user={user} />
//             }} />
//             <Route path={'/careers'} exact render={() => {
//               return <JobsPage />
//             }} />
//           </Switch>
//         </Router>
//       </ApolloProvider>
//     )
//   }
// }

// export default App;
